var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.getClass]},[_c('h1',{staticClass:"panel__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"panel__body"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }